import { AccessRightsStore } from 'store/access-rights/types.ts'
import { ENERGY_TYPES } from '@boltenergy-be/shared'

export const ACCESS_RIGHT_KEYS = {
  billingCycles: 'billingCycles',
  consumption: 'consumption',
  instalment: 'instalment',
  meterReadings: 'meterReadings',
  marketPrices: 'marketPrices'
} as const
export type AccessRightKeys = (typeof ACCESS_RIGHT_KEYS)[keyof typeof ACCESS_RIGHT_KEYS]

export const INITIAL_ACCESS_RIGHTS_STATE: AccessRightsStore = {
  billingCycles: {
    canAccess: { current: false, previous: false },
    showContent: { current: false, previous: false }
  },
  consumption: {
    showContent: false
  },
  instalment: {
    canAccess: false,
    showContent: false
  },
  meterReadings: {
    canAccess: {
      view: {
        [ENERGY_TYPES.electricity]: false,
        [ENERGY_TYPES.gas]: false
      },
      edit: {
        [ENERGY_TYPES.electricity]: false,
        [ENERGY_TYPES.gas]: false
      }
    },
    showContent: false
  },
  marketPrices: {
    todayTomorrow: {
      canAccess: false
    },
    historic: {
      canAccess: false
    }
  }
}
